import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import CssBaseline from '@mui/material/CssBaseline';
import ProtectedRoute from './layout/ProtectedRoute';
import PublicRoute from './layout/PublicRoute';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DevicesListPage from './pages/DevicesListPage';
import DeviceDetailsPage from './pages/DeviceDetailsPage';
import AccountPage from './pages/AccountPage';

const theme = createTheme({
  palette: {
    background: {
      default: '#ccc', // Άλλαξέ το από #fafafa σε ό,τι θες
      paper: '#ffffff',
    },
    primary: {
      light: '#FFECB3',
      main: '#FFC107',
      dark: '#FFA000',
    },
    secondary: {
      main: '#009688',
    },
    text: {
      primary: '#000', // Το κίτρινο που θέλεις
      secondary: 'rgba(0, 0, 0, 0.6)', // Το κίτρινο που θέλεις
      disabled: 'rgba(0, 0, 0, 0.38)', // Μαύρο κείμενο πάνω στο κίτρινο για να διαβάζεται
    },
    greyCustom: {
      soft: '#f5f5f5',
      main: '#9e9e9e',
      dark: '#616161',
    },
  },
  components: {
    // Προαιρετικά: Αν θες το focus border να είναι πιο έντονο
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.dark,
          },
        }),
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          overflowY: 'scroll',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: ({ theme }) => ({
          //color: theme.palette.common.white,
        }),
        text: ({ theme }) => ({
          color: theme.palette.text.secondary,
          '&:hover': {
            color: theme.palette.text.primary
          },
        })
      },
    },
  },
});

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
          <CssBaseline />

          <Routes >
            <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
            <Route path="/" element={<ProtectedRoute><DevicesListPage /></ProtectedRoute>} />
            <Route path="/devices" element={<ProtectedRoute><DevicesListPage /></ProtectedRoute>} />
            <Route path="/devices/:id" element={<ProtectedRoute><DeviceDetailsPage /></ProtectedRoute>} />
            <Route path="/devices/:id/:tab?" element={<ProtectedRoute><DeviceDetailsPage /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><AccountPage/></ProtectedRoute>} />
            <Route path="/account/change-info" element={<ProtectedRoute><AccountPage/></ProtectedRoute>} />
            <Route path="/account/change-password" element={<ProtectedRoute><AccountPage/></ProtectedRoute>} />
          </Routes>
      </ThemeProvider>
    </Router>
  );
}

export default App;
